import React, { useState } from "react";
import { Row, Accordion } from "react-bootstrap";
import "./OpereDiUrbanizzazi.scss";
import { useTranslation } from "react-i18next";
import Hero from "../../common/Hero/Hero";
import parse from 'html-react-parser';

import { Link } from 'react-router-dom';

import { getCorrectLink } from '../../../helpers/helpers'
import getMenuConfig from "../../../helpers/menuConfig";
const { opereDiUrbanizzazione: { pdf, zip, url } } = getMenuConfig();
const SingleOpere = ({ element }) => {
  return (
    <div className="accordion-body-item">
      {element.label ? (
        <div className="accordion-body-item-header">
            <h4 className='headline-fs6'>
              {element.label}
            </h4>
        </div>
      ) : null}
     <Row className="accordion-body-item-content">
  {parse(element.description || '')}
</Row>
    </div>
  );
};

const OpereChildren = (data, t) => {

  return (
    <>
      {data.map((element, i) => {
        return <SingleOpere element={element} key={i} />;
      })}
    </>
  );
};

const OpereDiUrbanizzazi = () => {
const { t } = useTranslation();

  const data = [
    {
      id: "1223",
      category: "Assemblea dei opere",
      folders: [
        {
          label: `${t("opere.label1.title")}`,
          id: "1a3",
          children: [
            {
              label: "Verbale asseblea straordinaria",
              description: `
              <p className="paragraph-large-fs7">${t("opere.label1.paragraph1")}</p>
              <ul>
                    <li className="paragraph-large-fs7">${t("opere.label1.paragraph1.li1")}&nbsp;<a href="${getCorrectLink(url.whatWeDo)}" className="link paragraph-large-fs7" target="_blank"">${t("opere.label1.paragraph1.li1.link")}<a></li>
                    <li className="paragraph-large-fs7">${t("opere.label1.paragraph1.li2")}</li>
                    <li className="paragraph-large-fs7">${t("opere.label1.paragraph1.li3")}&nbsp;<a href="${getCorrectLink(pdf.regolamentoDelServiziIdrico)}" className="link paragraph-large-fs7" download>${t("opere.label1.paragraph1.li3.link")}</a></li>
                  </ul>
                  <p className="paragraph-large-fs7">${t("opere.label1.paragraph2")}&nbsp;<a href="${getCorrectLink(url.invarianzaIdraulica)}" className="link paragraph-large-fs7" target="_blank">${t("opere.label1.paragraph2.link")} </a> ${t("opere.label1.paragraph2.part2")}</p>
              `
            }
          ],
        },
        {
          label: `${t("opere.label2.title")}`,
          id: "a22",
          children: [
            {
              description: `
              <p className="paragraph-large-fs7">${t("opere.label2.paragraph1")} <a href="mailto:piani.urbanistici@gruppocap.it" target="_blank" className="link paragraph-large-fs7">${t("opere.label2.paragraph1.link")}</a> ${t("opere.label2.paragraph1.part2")}</p>
              <ul>
                <li className="paragraph-large-fs7">${t("opere.label2.li1")} <a href="${getCorrectLink(pdf.richiestaDiParereTecnico)}" className="link paragraph-large-fs7" download>${t("opere.label2.li1.link")}</a>${t("opere.label2.li1.part2")}</li>
                <li className="paragraph-large-fs7">${t("opere.label2.li2")} <a href="${getCorrectLink(pdf.asseverazioneDeiContenuti)}" className="link paragraph-large-fs7" download>${t("opere.label2.li2.link")}</a></li>
                <li className="paragraph-large-fs7">${t("opere.label2.li3")} <a href="${getCorrectLink(pdf.allegatoSicurezza)}" className="link paragraph-large-fs7" download>${t("opere.label2.li3.link")}</a></li>
              </ul>
              `
            }
          ],
        },
        {
          label: `${t("opere.label3.title")}`,
          id: "312s",
          children: [
            {
              description: `
              <p className="paragraph-large-fs7">${t("opere.label3.paragraph1")} <a href="mailto:piani.urbanistici@gruppocap.it" target="_blank" className="link paragraph-large-fs7">${t("opere.label3.paragraph1.link")}</a>${t("opere.label3.paragraph1.part2")}</p>
              <ul>
                <li className="paragraph-large-fs7">${t("opere.label3.li1")} <a href="${getCorrectLink(pdf.richiestaDiParereTecnico)}" download className="link paragraph-large-fs7">${t("opere.label3.li1.link")}</a>${t("opere.label3.li1.part2")}</li>
                <li className="paragraph-large-fs7">${t("opere.label3.li2")} <a href="${getCorrectLink(zip.specificheAsBuild)}" download className="link paragraph-large-fs7">${t("opere.label3.li2.link")}</a></li>
                <li className="paragraph-large-fs7">${t("opere.label3.li3")} <a href="${getCorrectLink(zip.specificheAsBuild2019)}" download className="link paragraph-large-fs7">${t("opere.label3.li3.link")}</a></li>
              </ul>
              <p className="paragraph-large-fs7"><a href="mailto:ufficio.sit@gruppocap.it" target="_blank" className="link paragraph-large-fs7">${t("opere.label3.paragraph2.link")}</a>.</p>
              `
            },
          ],
        },
        {
          label: `${t("opere.label4.title")}`,
          id: "313s",
          children: [
            {
              description: `
              <p className="paragraph-large-fs7">${t("opere.label4.paragraph1")} <a href="${getCorrectLink(pdf.tariffario)}" download className="link paragraph-large-fs7">${t("opere.label4.paragraph1.link")}</a></p>
              <p className="paragraph-large-fs7">${t("opere.label4.paragraph2")} <a href="mailto:piani.urbanistici@gruppocap.it" target="_blank" className="link paragraph-large-fs7">${t("opere.label4.paragraph2.link")}</a>${t("opere.label4.paragraph2.part2")}</p>`
            },
          ],
        },
      ],
    },

];

const [key] = useState(data[0].id);
const [opere] = useState(data);
const [openId, setOpenId] = useState(null);
const toggleAccordion = (id) => {
  setOpenId((prev) => (prev === id ? null : id));
};
  
const ListOpere = () => {
  const opereObject = opere.find((item) => item.id === key);
  if (!opereObject) return null;

  return (
      <>
        {opereObject.folders.map((item, index) => {
          const eventKey = `work-${index}`;
          const headerId = `acc-header-${index}`;
          const panelId  = `acc-panel-${index}`;
          const isExpanded = openId === index;

          return (
            <div className="container accordion-component">
              <Accordion
                key={`accordion Chapter${index}--accordion`}
                onSelect={() => toggleAccordion(index)}
              >
                <Accordion.Toggle
                  key={`accordion-${eventKey}`}
                  className={`accordion-header headline-bold-fs4 ${isExpanded ? 'open' : ''}`}
                  as="h2"
                  eventKey={eventKey}
                >
                  <button
                    id={headerId}
                    type="button"
                    className="accordion-header-button headline-bold-fs4"
                    aria-expanded={isExpanded}
                    aria-controls={panelId}
                  >
                    {item.label}
                  </button>
                </Accordion.Toggle>

                <div
                  id={panelId}
                  className="accordion-body-container"
                  role="region"
                  aria-labelledby={headerId}
                  aria-hidden={!isExpanded}
                >
                  <Accordion.Collapse eventKey={eventKey}>
                    <div className="accordion-body">
                      {item.children && OpereChildren(item.children, t)}
                    </div>
                  </Accordion.Collapse>
                </div>
              </Accordion>       
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div className="OpereDiUrbanizzazi" data-testid="OpereDiUrbanizzazi">
      <Hero
        backTo={"/"}
        backToText={t("common.back.home")}
        title={t("opere.title")}
      />
      <div className="container OpereDiUrbanizzazi-component">
        <div className="richtext-wrapper">
            <h2 className="headline-bold-fs2">{t("opere.acquedotto")}</h2>
            <p>
              {t("opere.acquedotto.paragraph1")}
              {" "}
              <Link to={'/estensione-rete-esistente'}>
                {t("opere.acquedotto.paragraph1.link")}
              </Link>
            </p>
            <p className="mt-text">
              {t("opere.acquedotto.paragraph2")}
            </p>
            <p className="rm-mt-text">
              <a href={getCorrectLink(pdf.regolamentoDelServiziIdrico)} 
                download
                style={{ marginTop: 0, marginBottom: '10px' }}
              >
                {t("opere.acquedotto.paragraph2.link")}
              </a>
            </p>
        </div>
        <div className="richtext-wrapper">
          <h2 className="headline-bold-fs2">
            {t("opere.fognatura")}
          </h2>
          <div>
            {t("opere.fognatura.paragraph1")}
            {" "}
            <ul>
              <li className="paragraph-large-fs7">
                {t("opere.fogngatura.pragraph1.l1")}
              </li>
              <li className="paragraph-large-fs7">
                {t("opere.fogngatura.pragraph1.l2")}
              </li>
            </ul>
          </div>
          <p className="mt-text">
            {t("opere.fogngatura.pragraph2")}
            {" "}
            <Link to={'/estensione-rete-esistente'} className="link paragraph-large-fs7">
              {t("opere.acquedotto.paragraph1.link")}
            </Link>
          </p>
          <p>
            {t("opere.fogngatura.pragraph3")}
            <a href={getCorrectLink(pdf.elencoPrezzi)}
              download
            >
              {t("opere.fogngatura.pragraph3.link1")}
            </a>
            {" "}
            {t("opere.fogngatura.pragraph3.part2")}
          </p>
          <p className="mt-text">
            {t("opere.fogngatura.pragraph4")}
          </p>
          <p className="rm-mt-text">
            <a href={getCorrectLink(pdf.regolamentoDelServiziIdrico)} 
              download 
            >
              {t("opere.fogngatura.pragraph4.link1")}
            </a>
          </p>
          <p>
            <a href={getCorrectLink(url.documentiUtilili)}
              rel="noopener noreferrer" 
              target="_blank"
            >
              {t("opere.fogngatura.pragraph4.link2")}
            </a>
          </p>
        </div>
      </div>
      {ListOpere()}
    </div>
  );
};

OpereDiUrbanizzazi.propTypes = {};

export default OpereDiUrbanizzazi;
